<div class="animated fadeIn">

<div class="row">

    <div class="col-lg-12">
        <div class="card">
            
            <div class="card-body" style="min-height: 600px;">
             <h4 class="box-title">Help Document </h4>
             
              <br/>
              
                <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid" aria-describedby="bootstrap-data-table_info">
                                            <thead>
                                                <tr role="row">
                                                    <th>Document Title</th>
                                                    <th>File Name</th>
                                                    <th>Uploaded On</th>
                                                    
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody> 
                                            <tr role="row" class="odd" *ngFor="let fdata of fileData">
                                                <td class="sorting_1">{{fdata.docTitle}}</td>
                                                <td>{{fdata.docFile}}</td>
                                                <td>{{fdata.createDate| date:'dd-MM-yyyy HH:mm:ss'}}</td>
                                              <td>
                                               <a href="{{downLoadPath}}{{fdata.docFile}}" class="btn" ><i class="fa fa-download"></i></a>
                                              
                                               </td>
                                            </tr> 
                                            
                                            
                                        </tbody>
                                        </table>
            </div>
        </div>
       


</div>
</div><!-- .animated -->

